import styled, {css} from 'styled-components';
import { flexBox, fontSize } from '../../shared/styles/mixins'

export const PlanDetailsWrapper = styled.section`
  display: flex;
  @media(max-width: 600px) {
    flex-direction: column;
  }
`  
export const Main = styled.section`
  width: 60%;
  @media(max-width: 600px) {
    width: 100%;
  }
`  

export const PlanTypeSection = styled.section`
    padding: 16px 0;
`

export const TogglerSection = styled.section`
    width: 100%;
    height: 33px;
    margin-bottom: 30px;
`

export const GracePeriodPlanTypeSection = styled.article`
    color: #505050;
    font-size: .75rem;
    width: 300px;
    p {
        margin-top: 12px;
    }
`

export const PaymentFormatList = styled.section`
  ${fontSize(10)}
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding: 10px 0;
  @media screen and (min-width: 600px) {
    padding: 5px 0 0;
    margin-top: 20px;
  }
  ${({ complete }) =>
    complete &&
    css`
      @media screen and (min-width: 600px) {
        flex-flow: column;
        align-items: center;
      }
    `}
`
export const PaymentFormatListItem = styled.section`
  width: calc(50% - 40px);
  margin: 0 10px;
  ${({ complete }) =>
    complete &&
    css`
      @media screen and (min-width: 600px) {
        width: 100%;
        display: flex;
        margin-bottom: 8px;
        svg {
          margin-right: 5px;
        }
      }
    `}
`

export const PaymentFormatListItemHeader = styled.article`
  display: flex;
  align-items: center;
  span {
    font-size: .75rem;
    font-weight: 500;
    margin-left: 3px;
  }
`;

export const PaymentFormatListItemMain = styled.main`
    margin: 5px 0 20px 20px;
    color: #505050;
    font-size: .7rem;
    @media(max-width: 600px) {
      font-size: .6rem;
    }
`;


export const ServicesSection = styled.section`
  margin-top: 15px;
`

export const ServicesArticle = styled.article`
  margin: 8px 0 24px;
  color: #505050;
  p {
    margin-left: 13px;
    font-size: .75rem;
    font-weight: 400;
  }
  span {
    font-weight: 600;
    font-size: .75rem;
    color: #161A47;
  }
`
export const ServicesBullet = styled.span`
  color: #FE3E64 !important;
`

export const HowToUseSection = styled.article`
  display: flex;
  align-items: center;
` 
export const HowToUseItem = styled.article`
  position: relative;
  display: grid;
  grid-template-columns: 45px auto;
  grid-template-rows: 20px auto;
  grid-template-areas:
      'icon title'
      'icon description';
  margin-bottom: 24px;
  align-items: center;
  &:first-child{
    margin-top: 24px;
  }
  svg {
    grid-area: icon;
  }
  span {
    grid-area: title;
    font-weight: 600;
  }
  p {
    grid-area: description;
  }
` 

export const StepBullet = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50px;
  background-color: #FE3E64;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: 600;
  position: absolute;
  top: 12px;
  left: -12px;
` 

export const CounterButtom = styled.button`
  background: #FE3E64;
  color: white;
  border-radius: 50px;
  height: 24px;
  width: 24px;
` 

export const CounterInput = styled.input`
  border: 1px solid;
  margin: 0 16px;
  height: 34px;
  width: 60px;
  padding: 0 20px;
  text-align: center;
` 






export const Aside = styled.aside`
    background-color: #F3F7FC;
    width: 40%;
    height: 100%;
    position: fixed;
    right: 0;
    top: 133px;
    padding: 89px 0 59px 37px;
    display: flex;
    flex-direction: column;
    @media(max-width: 600px) {
      position: relative;
      width: 100%;
      top: 15px;
      padding: 40px;
    }
`
export const PlanLabel = styled.p`
    color: #161A47;
    font-weight: 600;
    font-size: .75rem;
`
export const PlanName = styled.h2`
    color: #161A47;
    font-weight: 700;
    font-size: 2rem;
    margin-top: 5px;
`
export const GracePeriod = styled.article`
    width: 113px;
    background: #70D226;
    color: white;
    border-radius: 3px;
    padding: 2px 6px;
    font-weight: 600;
    margin: 19px 0 120px 0;
    font-size: .875rem;
    ${({hasGracePeriod}) => hasGracePeriod && css`
      background: #ff842c;
      width: 142px;
    `}
`
export const TotalLifes = styled.article`
    color: #121A3D;
    font-size: .875rem;
    padding-bottom: 13px;
    border-bottom: 1px solid #DBDBDB;
    strong {
        font-size: 1.25rem;
    }
    p {
        margin-top: 4px;
        color: #707070;
        font-size: .625rem;
    }
`
export const TotalValue = styled.article`
    margin-top: 22px;
    color: #707070;
    font-size: .875rem;
    p {
        font-size: .75rem;
    }
`
export const Price = styled.article`
    color: #000;
    font-size: 1.875rem;
    font-weight: 700;
`

